module.exports = __webpack_public_path__ + "static/img/5.0ce8885.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/5.png
// module id = r7t1
// module chunks = 0